import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import {
  Dialog,
  Text,
  TextPriority,
  TextTypography,
  Button,
  ButtonPriority,
} from '..';
import { AsyncVisualTestWrapper } from '../../test/visualTestWrapper';
import { EditorShell } from '../../test/visual/VisualAsync';
// import { snapWithDarkTheme } from '../../test/visualTestUtils';

// const MobileDialogWithContent = (props) => (
//   <Dialog isOpen {...props}>
//     <div className="content" style={{ textAlign: 'center' }}>
//       <Text typography={TextTypography.largeTitle} tagName="div">
//         Discard draft?
//       </Text>
//       <div
//         className="text-container"
//         style={{ marginTop: '16px', marginBottom: '32px' }}
//       >
//         <Text typography={TextTypography.runningText} tagName="div">
//           Are You Sure you want to discard the changes you made?
//         </Text>
//       </div>
//       <div className="primary-btn-container" style={{ marginBottom: '8px' }}>
//         <Button upgrade style={{ width: '100%', boxSizing: 'border-box' }}>
//           PRIMARY
//         </Button>
//       </div>
//       <Button
//         upgrade
//         priority={ButtonPriority.basicSecondary}
//         style={{ width: '100%', boxSizing: 'border-box' }}
//       >
//         SECONDARY
//       </Button>
//     </div>
//   </Dialog>
// );

const DialogWithContent = (props) => (
  <DialogWithCustomContent
    {...props}
    content={
      <div>
        <div>Do you really want to delete the selected files?</div>
        <div>Once removed, cannot be undone.</div>
      </div>
    }
  />
);

const DialogWithCustomContent = (props) => (
  <Dialog isOpen {...props}>
    <div className="content" style={{ textAlign: 'center' }}>
      <Text typography={TextTypography.largeTitle}>Are You Sure?</Text>
      <div
        className="text-container"
        style={{ marginTop: '24px', marginBottom: '36px' }}
      >
        <Text typography={TextTypography.listText} tagName="div">
          {props.content}
        </Text>
      </div>
      <Button
        upgrade
        priority={
          props.wiredToSiteColors
            ? ButtonPriority.secondary
            : ButtonPriority.basicSecondary
        }
        style={{ marginLeft: '10px' }}
      >
        SECONDARY
      </Button>
      <Button
        upgrade
        style={{ marginLeft: '10px' }}
        priority={
          props.wiredToSiteColors
            ? ButtonPriority.primary
            : ButtonPriority.basic
        }
      >
        PRIMARY
      </Button>
    </div>
  </Dialog>
);

const BWDialogWithText = (props) => (
  <Dialog isOpen forceBWTheme {...props}>
    <div className="content" style={{ textAlign: 'center' }}>
      <Text
        typography={TextTypography.largeTitle}
        priority={TextPriority.primary}
      >
        Primary text
      </Text>
    </div>
    <div
      className="text-container"
      style={{ marginTop: '24px', marginBottom: '36px' }}
    >
      <Text
        typography={TextTypography.listText}
        priority={TextPriority.secondary}
      >
        Secondary text
      </Text>
    </div>
  </Dialog>
);

const runDesktopSnapshots = (isRtl) => {
  story('Basic', () => {
    snap(`Desktop with default props  ${isRtl ? 'rtl' : ''}`, (doSnap) => (
      <EditorShell>
        <AsyncVisualTestWrapper
          isRtl={isRtl}
          isMobile={false}
          onDoneCallback={doSnap}
        >
          <Dialog isOpen />
        </AsyncVisualTestWrapper>
      </EditorShell>
    ));
    snap(
      `Desktop Dialog with some content  ${isRtl ? 'rtl' : ''}`,
      (doSnap) => (
        <AsyncVisualTestWrapper
          isRtl={isRtl}
          isMobile={false}
          onDoneCallback={doSnap}
        >
          <DialogWithContent />
        </AsyncVisualTestWrapper>
      ),
    );
    const longContent = (
      <div>
        <div>
          Do you really really really really really really really really really
          really really really really really really really really really really
          really really really really really really really really really really
          really really really really want to delete the selected files?
        </div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
        <div>Once removed, cannot be undone.</div>
      </div>
    );

    snap(
      `Desktop Dialog with long content  ${isRtl ? 'rtl' : ''}`,
      (doSnap) => (
        <AsyncVisualTestWrapper
          isRtl={isRtl}
          isMobile={false}
          onDoneCallback={doSnap}
        >
          <DialogWithCustomContent content={longContent} />
        </AsyncVisualTestWrapper>
      ),
    );
  });
};

// skipped flaky visual test
// const runMobileSnapshots = (isRtl) => {
//   story('Basic', () => {
//     snap(`Mobile with default props  ${isRtl ? 'rtl' : ''}`, (doSnap) => (
//       <AsyncVisualTestWrapper isRtl={isRtl} isMobile onDoneCallback={doSnap}>
//         <MobileDialogWithContent />
//       </AsyncVisualTestWrapper>
//     ));
//     snap(
//       `Mobile with not fullscreen version  ${isRtl ? 'rtl' : ''}`,
//       (doSnap) => (
//         <AsyncVisualTestWrapper isRtl={isRtl} isMobile onDoneCallback={doSnap}>
//           <MobileDialogWithContent notFullscreenOnMobile />
//         </AsyncVisualTestWrapper>
//       ),
//     );
//   });
// };

visualize('Dialog', () => {
  // [false, true].map((value) => runMobileSnapshots(value));
  [false, true].map((value) => runDesktopSnapshots(value));

  story('Wired to palette', () => {
    snap('Dialog with some content', () => {
      return (
        <EditorShell>
          <DialogWithContent wiredToSiteColors />
        </EditorShell>
      );
    });

    // TODO - this test is disabled until we figure out how to changePalette with cssVars
    // snapWithDarkTheme('with dark theme', () => (
    //   <DialogWithContent wiredToSiteColors />
    // ));
  });

  story('Force black and white theme', () => {
    snap('Dialog with Text', () => {
      return <BWDialogWithText />;
    });
  });
});
